<!-- src/app/demo/components/documents/create-document/create-document.component.html -->
<div class="grid">
    <div class="col-12">
        <form>
            <p-card header="Create New Document" [formGroup]="documentForm">
                <p-messages [(value)]="messages" [closable]="true" />
                <div class="p-fluid p-formgrid grid w-full" >
                    <div class="field col-12 md:col-4 mb-0">
                        <label htmlFor="documentName" class="text-sm text-500"
                            >Document Name</label
                        >
                        <input
                            type="text"
                            id="documentName"
                            placeholder="Document Name"
                            pInputText
                            formControlName="documentName"
                        />
                    </div>
                    <div class="field col-12 md:col-4 mb-0">
                        <label
                            htmlFor="documentCategory"
                            class="text-sm text-500"
                            >Document Category</label
                        >
                        <span class="p-input-icon-left w-25rem">
                            <p-dropdown
                                id="gender"
                                optionLabel="name"
                                optionValue="value"
                                [options]="categories"
                                formControlName="documentCategory"
                                placeholder="Select Document Category"
                                styleClass="w-full"
                                inputStyleClass="w-full p-input-icon-left"
                            />
                        </span>
                    </div>

                    <div class="p-fluid ml-2 mt-1 p-formgrid grid w-full" >
                        <div class="field w-full col-12 md:col-4 mb-0">
                            <p-checkbox
                                name="requiresExpiryDate"
                                formControlName="requiresExpiryDate"
                                [binary]="true"
                                inputId="requiresExpiryDate"
                                label="Requires Expiry Date ?"
                            ></p-checkbox>
                        </div>
                    </div>
                    <div class="p-fluid ml-2 mb-1 w-full p-formgrid grid">
                        <div class="field col-12 md:col-4 mb-0">
                            <p-checkbox
                                name="requiresIdentifier"
                                formControlName="requiresIdentifier"
                                [binary]="true"
                                inputId="requiresIdentifier"
                                label="Requires Identifier ?"
                            ></p-checkbox>
                        </div>
                    </div>
                    
                    
                </div>
                <ng-template class="align-items-right" pTemplate="footer">
                    <div class="flex gap-2 mt-1">
                        <p-button
                            icon="pi pi-times-circle"
                            pRipple
                            label="Clear"
                            severity="secondary"
                        />
                        <button
                            icon="pi pi-check"
                            label="Save"
                            severity="primary"
                            pTooltip="Create new Document"
                            (click)="onDocumentSubmit()"
                            pButton
                            pRipple
                        ></button>
                    </div>
                </ng-template>
            </p-card>
        </form>
    </div>
</div>
